// extracted by mini-css-extract-plugin
export default {"eventDetails":"EventDetails_eventDetails__NecEh","whenSection":"EventDetails_whenSection__hJMU2","title":"EventDetails_title__fHLao","data":"EventDetails_data__tdaC9"};